import { Modal, ModalProps } from '@/modules/common/components/Modal';
import { Button } from '@mui/material';

type ConfirmationModalProps = Omit<
  ModalProps,
  'onClose' | 'showCloseButton' | 'children'
> & {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export function ConfirmationModal({
  onConfirm,
  onCancel,
  isLoading,
  ...props
}: ConfirmationModalProps) {
  return (
    <Modal {...props} onClose={onCancel} showCloseButton={false}>
      <>
        <div className="flex gap-3 justify-end">
          <Button variant="contained" onClick={onConfirm} loading={isLoading}>
            Yes
          </Button>
          <Button variant="outlined" onClick={onCancel} loading={isLoading}>
            No
          </Button>
        </div>
      </>
    </Modal>
  );
}
